/**
 * Returns a new Date object shifted to the Europe/Brussels timezone.
 * When browser is in a different timezone, calling local Date methods (like getHours, getMonth)
 * on the returned date object will return the values in Brussels timezone.
 * 
 * @param {Date} [date] - Optional date to convert. Defaults to current time.
 * @returns {Date}
 */
export const getBrusselsDate = (date = new Date()) => {
  const tzString = date.toLocaleString('en-US', { timeZone: 'Europe/Brussels' });
  return new Date(tzString);
};
